"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appNameKeys = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
exports.appNameKeys = {
    management: legacy_enums_1.ClientType.Management,
    website: legacy_enums_1.ClientType.Website,
    iOS: legacy_enums_1.ClientType.iOS,
    customerApp: legacy_enums_1.ClientType.CustomerApp,
    driverApp: legacy_enums_1.ClientType.DriverApp,
    // deprecated
    site: "site",
    mobileApp: "mobileApp",
};
//# sourceMappingURL=ApplicationNames.js.map